

export class PermissionGroupAddModel {
    permissions: number[] = new Array<number>();
    permissionGroupName: string = '';
    notificationGroup: boolean = false;
}